<section class="experience section" id="experience">
  <div class="shell-container experience__grid reveal" appRevealOnScroll="80ms">
    <div class="experience__intro reveal" appRevealOnScroll="120ms">
      <div class="badge">{{ content.badge }}</div>
      <h2>{{ content.heading }}</h2>
      <p class="experience__lede">{{ content.lede }}</p>
    </div>

    <div
      class="experience__card reveal"
      *ngFor="let card of content.cards"
      [appRevealOnScroll]="card.delay"
    >
      <p class="experience__label">{{ card.label }}</p>
      <ul class="experience__list">
        <li *ngFor="let item of card.items">{{ item }}</li>
      </ul>
    </div>
  </div>
</section>
